import { graphql } from '@graphql/gql';

export const SEARCH_SCHEDULE_WITH_SPEAKERS = graphql(`
  query SEARCH_SCHEDULE_WITH_SPEAKERS($criteria: MyAgendaCriteria) {
    myAgenda(criteria: $criteria) {
      pagination {
        limit
        totalCount
        nextToken
        currentToken
      }
      data {
        id
        name
        description
        start
        end
        status
        enrolled
        included
        virtual
        virtualLink
        openForRegistration
        featured
        contentTags {
          name
        }
        category {
          id
          name
        }
        location {
          id
          name
          code
        }
        exhibitors {
          id
          name
          description
          profileLogoUrl
          featured
        }
        webcast {
          id
          eventId
          sessionId
          format
          title
          sourceId
          provider
          meetingId
          details
          playerType
          type
          simulatedLive
          onDemandVideo
          isOnDemandContentPlayable
          solutionType
          player {
            id
            playerTypeProvider
            duration
            simuliveOffset
            stream {
              id
              status
            }
          }
        }
        type
        openForAttendeeHub
        participants {
          id
          firstName
          lastName
          profileImageUrl
          type
        }
        speakers {
          id
          firstName
          lastName
          company
          email
          title
          biography
          profileImageUri
          socialLinks {
            facebookUrl
            twitterUrl
            linkedInUrl
          }
        }
      }
    }
  }
`);
